module.exports = __webpack_public_path__ + "static/media/bar6.4d197ac7.svg";